// src/components/store/sections/testimonials/TestimonialV8BentoreviewsSunsetAmber.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV8BentoreviewsSunsetAmber(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={8}
      archKey="bento_reviews"
      archLabel="Bento Review Matrix"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
